import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddMaximumCommutePreferenceMutationVariables = Types.Exact<{
  timeMinutes: Types.Scalars['Int']['input'];
}>;


export type AddMaximumCommutePreferenceMutation = { __typename?: 'Mutation', addJobSeekerProfileStructuredDataPreference?: { __typename?: 'AddJobSeekerProfileStructuredDataPreferencePayload', ignore: 'AddJobSeekerProfileStructuredDataPreferencePayload', preference?: { __typename?: 'JobSeekerProfileStructuredDataPreference', id?: string | null, maximumCommute?: { __typename?: 'JobSeekerProfileStructuredDataCommute', timeMinutes?: number | null } | null } | null } | null };


export const AddMaximumCommutePreferenceDocument = gql`
    mutation AddMaximumCommutePreference($timeMinutes: Int!) {
  addJobSeekerProfileStructuredDataPreference(
    input: {maximumCommute: {timeMinutes: $timeMinutes}}
  ) {
    ignore: __typename
    preference {
      id
      maximumCommute {
        timeMinutes
      }
    }
  }
}
    `;
export type AddMaximumCommutePreferenceMutationFn = Apollo.MutationFunction<AddMaximumCommutePreferenceMutation, AddMaximumCommutePreferenceMutationVariables>;

/**
 * __useAddMaximumCommutePreferenceMutation__
 *
 * To run a mutation, you first call `useAddMaximumCommutePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMaximumCommutePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMaximumCommutePreferenceMutation, { data, loading, error }] = useAddMaximumCommutePreferenceMutation({
 *   variables: {
 *      timeMinutes: // value for 'timeMinutes'
 *   },
 * });
 */
export function useAddMaximumCommutePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<AddMaximumCommutePreferenceMutation, AddMaximumCommutePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMaximumCommutePreferenceMutation, AddMaximumCommutePreferenceMutationVariables>(AddMaximumCommutePreferenceDocument, options);
      }
export type AddMaximumCommutePreferenceMutationHookResult = ReturnType<typeof useAddMaximumCommutePreferenceMutation>;
export type AddMaximumCommutePreferenceMutationResult = Apollo.MutationResult<AddMaximumCommutePreferenceMutation>;
export type AddMaximumCommutePreferenceMutationOptions = Apollo.BaseMutationOptions<AddMaximumCommutePreferenceMutation, AddMaximumCommutePreferenceMutationVariables>;